<template>
    <div class="col conteudo">
        <div class="col">
            <img src="../../../assets/img/logo_np.png" class="logo mt-3" title="Grupo Negócios Públicos">
            <h2 class="formularios pt-4">Responsavel da inscrição</h2>
            <p class="descritivo">Agora informe os contatos para assuntos referentes a inscrição</p>
        </div>
        <div class="row">
            <div class="form-group col-lg-4">
                <label class="pb-1 pt-3 font-1">Nome *</label>
                <span class="field-validation-valid labelValidacao"></span>
                <input class="form-control" type="text" id="nome" v-model="inscricao.nmNomeResponsavel">
            </div>
            <div class="form-group col-lg-4">
                <label for="e-mail" class="pb-1 pt-3 font-1">E-mail *</label>
                <span class="field-validation-valid labelValidacao"></span>
                <input class="form-control" type="email" id="e-mail" v-model="inscricao.dsEmailResponsavel">
            </div>
            <div class="form-group col-lg-4">
                <label for="telefone3" class="pb-1 pt-3 font-1">Telefone</label>
                <span class="field-validation-valid labelValidacao"></span>
                <input class="form-control" type="text" id="telefone3" v-maska="'(##) ####-####'" v-model="inscricao.nrTelefoneResponsavel" >
            </div>
            <div class="col-lg-4 form-group">
                <label for="departamento" class="pt-3 font-1 pb-1">Departamento *</label>
                <span class="field-validation-valid labelValidacao"></span>
                <select class="form-control form-select" id="departamento" v-model="inscricao.idDepartamentoResponsavel">
                    <option value="0">Selecione</option>
                    <option value="3">Administrativo</option>
                    <option value="87">Agricultura</option>
                    <option value="34">Arquitetura</option>
                    <option value="89">Arrecadação</option>
                    <option value="23">Assistência Social</option>
                    <option value="79">Associado do IRIB</option>
                    <option value="12">Auditoria</option>
                    <option value="17">Biblioteca</option>
                    <option value="69">Cadastro</option>
                    <option value="18">Cadastro de Fornecedores</option>
                    <option value="91">Coletoria</option>
                    <option value="40">Comissão de Processo Administrativo Disciplinar</option>
                    <option value="95">Comissão de Regularização Fundiária</option>
                    <option value="21">Compras</option>
                    <option value="10">Comunicação/Cerimonial/Eventos</option>
                    <option value="4">Contabilidade</option>
                    <option value="5">Contratos/Convênios</option>
                    <option value="7">Controladoria</option>
                    <option value="28">Controle Interno</option>
                    <option value="36">Convênios</option>
                    <option value="44">Corregedoria</option>
                    <option value="68">Desapropriação</option>
                    <option value="46">Desenvolvimento Social</option>
                    <option value="48">Desenvolvimento Urbano</option>
                    <option value="16">Direção</option>
                    <option value="24">Educação</option>
                    <option value="32">Engenharia</option>
                    <option value="11">Engenharia</option>
                    <option value="8">Financeiro</option>
                    <option value="25">Gabinete</option>
                    <option value="93">Gestao de pessoas</option>
                    <option value="38">Gestão Estratégica</option>
                    <option value="20">Governança</option>
                    <option value="50">Habitação Social</option>
                    <option value="35">Infraestrutura</option>
                    <option value="1">Jurídico</option>
                    <option value="77">LGPD</option>
                    <option value="2">Licitação</option>
                    <option value="15">Logística/Serviços Gerais</option>
                    <option value="31">Manutenção Predial</option>
                    <option value="9">Material/Almoxarifado/Patrimônio</option>
                    <option value="52">Meio Ambiente</option>
                    <option value="54">Mobilidade Urbana</option>
                    <option value="81">Núcleo Sustentabilidade</option>
                    <option value="33">Obras</option>
                    <option value="73">Orçamento de Obras</option>
                    <option value="27">Outro</option>
                    <option value="75">Ouvidoria</option>
                    <option value="67">Patrimônio</option>
                    <option value="14">Planejamento</option>
                    <option value="66">Plano Diretor</option>
                    <option value="83">PRESIDENCIA</option>
                    <option value="26">Procuradoria</option>
                    <option value="19">Projetos</option>
                    <option value="39">Projetos em Bim</option>
                    <option value="65">Regulação Urbano</option>
                    <option value="56">Regularização Fundiária</option>
                    <option value="6">Rh/Pessoas/Capacitação</option>
                    <option value="70">Saneamento</option>
                    <option value="22">Saúde</option>
                    <option value="64">Secretaria de Administração</option>
                    <option value="63">Secretaria de Governo</option>
                    <option value="72">Setor de Recursos Humanos</option>
                    <option value="71">Setor de Treinamento</option>
                    <option value="58">Setor de Tributos</option>
                    <option value="62">Social</option>
                    <option value="85">suprimentos</option>
                    <option value="37">Terceirização</option>
                    <option value="42">Tesouraria</option>
                    <option value="13">Ti</option>
                    <option value="60">Urbanismo</option>
                </select>
            </div>
            <div class="col-lg-4 form-group">
                <label for="funcao" class="pt-3 font-1 pb-1">Função *</label>
                <span class="field-validation-valid labelValidacao"></span>
                <select class="form-control form-select" id="funcao" v-model="inscricao.idFuncaoResponsavel">
                    <option value="0">Selecione</option>
                    <option value="40">Adjunto</option>
                    <option value="46">Administrador(a)</option>
                    <option value="1">Advogado</option>
                    <option value="95">Agente de Contratação</option>
                    <option value="41">Analista</option>
                    <option value="61">Analista Fundiário</option>
                    <option value="53">Analista judiciário</option>
                    <option value="47">Arquiteto</option>
                    <option value="91">Arquiteto e Urbanista</option>
                    <option value="2">Assessor</option>
                    <option value="87">Assessor Administrativo</option>
                    <option value="3">Assessor Jurídico</option>
                    <option value="4">Assistente</option>
                    <option value="5">Assistente Jurídico</option>
                    <option value="63">Assistente Social</option>
                    <option value="6">Auditor</option>
                    <option value="7">Auxiliar</option>
                    <option value="8">Bibliotecário</option>
                    <option value="86">Chefe de Departamento</option>
                    <option value="90">Chefe de Gabinete</option>
                    <option value="94">Chefe de Políticas Públicas Habitacionais</option>
                    <option value="9">Chefe de Setor</option>
                    <option value="85">Comercial</option>
                    <option value="101">Compliance</option>
                    <option value="11">Comprador</option>
                    <option value="12">Comprador e Pregoeiro</option>
                    <option value="97">Conselheiro</option>
                    <option value="44">Contador</option>
                    <option value="103">controlador</option>
                    <option value="13">Coordenador</option>
                    <option value="59">Corregedor</option>
                    <option value="65">Desenhista e Projetista</option>
                    <option value="92">Desenhista Projetista</option>
                    <option value="14">Diretor</option>
                    <option value="82">Diretor Jurídico</option>
                    <option value="83">Diretor Planejamento</option>
                    <option value="79">Diretor Presidente</option>
                    <option value="69">Diretor Social</option>
                    <option value="67">Diretor Técnico</option>
                    <option value="16">Encarregado</option>
                    <option value="17">Engenheiro</option>
                    <option value="45">Engenheiro</option>
                    <option value="71">Engenheiro Agrimensor</option>
                    <option value="78">Engenheiro Civil</option>
                    <option value="18">Fiscal de Contrato</option>
                    <option value="73">Fiscal Fundiário</option>
                    <option value="19">Gerente</option>
                    <option value="93">Gerente de Projetos</option>
                    <option value="80">Gerente de Regularização Fundiária</option>
                    <option value="81">Gerente de Urbanismo</option>
                    <option value="39">Gestor de Contratos</option>
                    <option value="55">Membro da Comissão de PAD</option>
                    <option value="21">Membro da CPL</option>
                    <option value="48">Orçamentista de Obras</option>
                    <option value="23">Ordenador de Despesas</option>
                    <option value="43">Outro</option>
                    <option value="42">Pesquisa de Preços</option>
                    <option value="24">Prefeito</option>
                    <option value="25">Pregoeiro</option>
                    <option value="10">Pregoeiro e Chefe de Setor</option>
                    <option value="15">Pregoeiro e Diretor</option>
                    <option value="20">Pregoeiro e Gerente</option>
                    <option value="22">Pregoeiro e Membro da CPL</option>
                    <option value="28">Pregoeiro e Presidente da CPL</option>
                    <option value="33">Pregoeiro e Responsável pela Licitação</option>
                    <option value="26">Presidente</option>
                    <option value="27">Presidente da CPL</option>
                    <option value="29">Procurador</option>
                    <option value="30">Pró-Reitor</option>
                    <option value="31">Reitor</option>
                    <option value="32">Responsável</option>
                    <option value="99">Responsável planejamento</option>
                    <option value="34">Secretário</option>
                    <option value="35">Secretário de Governo</option>
                    <option value="88">Secretário(a)</option>
                    <option value="36">Superintendente</option>
                    <option value="37">Supervisor</option>
                    <option value="49">Técnico</option>
                    <option value="51">Técnico judiciário</option>
                    <option value="57">Tesoureiro</option>
                    <option value="75">Topógrafo</option>
                    <option value="89">Urbanista</option>
                    <option value="38">Vice-Prefeito</option>
                    <option value="84">Vice-Presidente</option>
                </select>
            </div>
            <div class="form-group col-lg-4">
                <label class="pb-1 pt-3 font-1">Celular *</label>
                <span class="field-validation-valid labelValidacao"></span>
                <input class="form-control" type="text" id="celular3" v-maska="'(##) #####-####'" v-model="inscricao.nrCelularResponsavel">
            </div>
            <div class="form-group col-lg-4">
                <label for="data-nascimento" class="pb-1 pt-3 font-1">Data de Nascimento *</label>
                <span class="field-validation-valid labelValidacao"></span>
                <input class="form-control" type="text" id="data-nascimento" v-maska="'##/##/####'" v-model="inscricao.dtNascimentoResponsavel">
            </div>
        </div>
        <div class="col">
            <h2 class="formularios pt-4">Responsável Financeiro (Esse é o responsavel por receber a nota fiscal) </h2>
        </div>
        <div class="form-group col">
            <div class="form-check pt-1 mb-2">
                <input class="form-check-input" type="checkbox" id="responsavel-financeiro" v-model="inscricao.flMesmaPessoa">
                <label for="responsavel-financeiro" class="form-check-label font-1">
                    Mesma Pessoa
                </label>
            </div>
            <div class="row" v-if="!isDisabledMesmaPessoa">
                <div class="form-group col-lg-4">
                    <label for="nome2" class="pb-1 pt-3 font-1">Nome *</label>
                    <span class="field-validation-valid labelValidacao"></span>
                    <input class="form-control" type="text" id="nome2" v-model="inscricao.nmNomeFinanceiro" >
                </div>
                <div class="form-group col-lg-4">
                    <label for="e-mail2" class="pb-1 pt-3 font-1">E-mail *</label>
                    <span class="field-validation-valid labelValidacao"></span>
                    <input class="form-control" type="email" id="e-mail2" v-model="inscricao.dsEmailFinanceiro">
                </div>
                <div class="form-group col-lg-4">
                    <label for="telefone4" class="pb-1 pt-3 font-1">Telefone</label>
                    <span class="field-validation-valid labelValidacao"></span>
                    <input class="form-control" type="text" id="telefone4" v-maska="'(##) ####-####'" v-model="inscricao.nrTelefoneFinanceiro">
                </div>
                <div class="col-lg-4 form-group">
                    <label for="departamento2" class="pt-3 font-1 pb-1">Departamento *</label>
                    <span class="field-validation-valid labelValidacao"></span>
                    <select class="form-control form-select" id="departamento2" v-model="inscricao.idDepartamentoFinanceiro">
                        <option value="0">Selecione</option>
                        <option value="3">Administrativo</option>
                        <option value="87">Agricultura</option>
                        <option value="34">Arquitetura</option>
                        <option value="89">Arrecadação</option>
                        <option value="23">Assistência Social</option>
                        <option value="79">Associado do IRIB</option>
                        <option value="12">Auditoria</option>
                        <option value="17">Biblioteca</option>
                        <option value="69">Cadastro</option>
                        <option value="18">Cadastro de Fornecedores</option>
                        <option value="91">Coletoria</option>
                        <option value="40">Comissão de Processo Administrativo Disciplinar</option>
                        <option value="95">Comissão de Regularização Fundiária</option>
                        <option value="21">Compras</option>
                        <option value="10">Comunicação/Cerimonial/Eventos</option>
                        <option value="4">Contabilidade</option>
                        <option value="5">Contratos/Convênios</option>
                        <option value="7">Controladoria</option>
                        <option value="28">Controle Interno</option>
                        <option value="36">Convênios</option>
                        <option value="44">Corregedoria</option>
                        <option value="68">Desapropriação</option>
                        <option value="46">Desenvolvimento Social</option>
                        <option value="48">Desenvolvimento Urbano</option>
                        <option value="16">Direção</option>
                        <option value="24">Educação</option>
                        <option value="32">Engenharia</option>
                        <option value="11">Engenharia</option>
                        <option value="8">Financeiro</option>
                        <option value="25">Gabinete</option>
                        <option value="93">Gestao de pessoas</option>
                        <option value="38">Gestão Estratégica</option>
                        <option value="20">Governança</option>
                        <option value="50">Habitação Social</option>
                        <option value="35">Infraestrutura</option>
                        <option value="1">Jurídico</option>
                        <option value="77">LGPD</option>
                        <option value="2">Licitação</option>
                        <option value="15">Logística/Serviços Gerais</option>
                        <option value="31">Manutenção Predial</option>
                        <option value="9">Material/Almoxarifado/Patrimônio</option>
                        <option value="52">Meio Ambiente</option>
                        <option value="54">Mobilidade Urbana</option>
                        <option value="81">Núcleo Sustentabilidade</option>
                        <option value="33">Obras</option>
                        <option value="73">Orçamento de Obras</option>
                        <option value="27">Outro</option>
                        <option value="75">Ouvidoria</option>
                        <option value="67">Patrimônio</option>
                        <option value="14">Planejamento</option>
                        <option value="66">Plano Diretor</option>
                        <option value="83">PRESIDENCIA</option>
                        <option value="26">Procuradoria</option>
                        <option value="19">Projetos</option>
                        <option value="39">Projetos em Bim</option>
                        <option value="65">Regulação Urbano</option>
                        <option value="56">Regularização Fundiária</option>
                        <option value="6">Rh/Pessoas/Capacitação</option>
                        <option value="70">Saneamento</option>
                        <option value="22">Saúde</option>
                        <option value="64">Secretaria de Administração</option>
                        <option value="63">Secretaria de Governo</option>
                        <option value="72">Setor de Recursos Humanos</option>
                        <option value="71">Setor de Treinamento</option>
                        <option value="58">Setor de Tributos</option>
                        <option value="62">Social</option>
                        <option value="85">suprimentos</option>
                        <option value="37">Terceirização</option>
                        <option value="42">Tesouraria</option>
                        <option value="13">Ti</option>
                        <option value="60">Urbanismo</option>
                    </select>
                </div>
                <div class="col-lg-4 form-group">
                    <label for="funcao2" class="pt-3 font-1 pb-1">Função *</label>
                    <span class="field-validation-valid labelValidacao"></span>
                    <select class="form-control form-select" id="funcao2" v-model="inscricao.idFuncaoFinanceiro">
                        <option value="0">Selecione</option>
                        <option value="40">Adjunto</option>
                        <option value="46">Administrador(a)</option>
                        <option value="1">Advogado</option>
                        <option value="95">Agente de Contratação</option>
                        <option value="41">Analista</option>
                        <option value="61">Analista Fundiário</option>
                        <option value="53">Analista judiciário</option>
                        <option value="47">Arquiteto</option>
                        <option value="91">Arquiteto e Urbanista</option>
                        <option value="2">Assessor</option>
                        <option value="87">Assessor Administrativo</option>
                        <option value="3">Assessor Jurídico</option>
                        <option value="4">Assistente</option>
                        <option value="5">Assistente Jurídico</option>
                        <option value="63">Assistente Social</option>
                        <option value="6">Auditor</option>
                        <option value="7">Auxiliar</option>
                        <option value="8">Bibliotecário</option>
                        <option value="86">Chefe de Departamento</option>
                        <option value="90">Chefe de Gabinete</option>
                        <option value="94">Chefe de Políticas Públicas Habitacionais</option>
                        <option value="9">Chefe de Setor</option>
                        <option value="85">Comercial</option>
                        <option value="101">Compliance</option>
                        <option value="11">Comprador</option>
                        <option value="12">Comprador e Pregoeiro</option>
                        <option value="97">Conselheiro</option>
                        <option value="44">Contador</option>
                        <option value="103">controlador</option>
                        <option value="13">Coordenador</option>
                        <option value="59">Corregedor</option>
                        <option value="65">Desenhista e Projetista</option>
                        <option value="92">Desenhista Projetista</option>
                        <option value="14">Diretor</option>
                        <option value="82">Diretor Jurídico</option>
                        <option value="83">Diretor Planejamento</option>
                        <option value="79">Diretor Presidente</option>
                        <option value="69">Diretor Social</option>
                        <option value="67">Diretor Técnico</option>
                        <option value="16">Encarregado</option>
                        <option value="17">Engenheiro</option>
                        <option value="45">Engenheiro</option>
                        <option value="71">Engenheiro Agrimensor</option>
                        <option value="78">Engenheiro Civil</option>
                        <option value="18">Fiscal de Contrato</option>
                        <option value="73">Fiscal Fundiário</option>
                        <option value="19">Gerente</option>
                        <option value="93">Gerente de Projetos</option>
                        <option value="80">Gerente de Regularização Fundiária</option>
                        <option value="81">Gerente de Urbanismo</option>
                        <option value="39">Gestor de Contratos</option>
                        <option value="55">Membro da Comissão de PAD</option>
                        <option value="21">Membro da CPL</option>
                        <option value="48">Orçamentista de Obras</option>
                        <option value="23">Ordenador de Despesas</option>
                        <option value="43">Outro</option>
                        <option value="42">Pesquisa de Preços</option>
                        <option value="24">Prefeito</option>
                        <option value="25">Pregoeiro</option>
                        <option value="10">Pregoeiro e Chefe de Setor</option>
                        <option value="15">Pregoeiro e Diretor</option>
                        <option value="20">Pregoeiro e Gerente</option>
                        <option value="22">Pregoeiro e Membro da CPL</option>
                        <option value="28">Pregoeiro e Presidente da CPL</option>
                        <option value="33">Pregoeiro e Responsável pela Licitação</option>
                        <option value="26">Presidente</option>
                        <option value="27">Presidente da CPL</option>
                        <option value="29">Procurador</option>
                        <option value="30">Pró-Reitor</option>
                        <option value="31">Reitor</option>
                        <option value="32">Responsável</option>
                        <option value="99">Responsável planejamento</option>
                        <option value="34">Secretário</option>
                        <option value="35">Secretário de Governo</option>
                        <option value="88">Secretário(a)</option>
                        <option value="36">Superintendente</option>
                        <option value="37">Supervisor</option>
                        <option value="49">Técnico</option>
                        <option value="51">Técnico judiciário</option>
                        <option value="57">Tesoureiro</option>
                        <option value="75">Topógrafo</option>
                        <option value="89">Urbanista</option>
                        <option value="38">Vice-Prefeito</option>
                        <option value="84">Vice-Presidente</option>
                    </select>
                </div>
                <div class="form-group col-lg-4">
                    <label for="celular4" class="pb-1 pt-3 font-1">Celular *</label>
                    <span class="field-validation-valid labelValidacao"></span>
                    <input class="form-control" type="text" id="celular4" v-maska="'(##) #####-####'" v-model="inscricao.nrCelularFinanceiro">
                </div>
                <div class="form-group col-lg-4">
                    <label for="data-nascimento2" class="pb-1 pt-3 font-1">Data de Nascimento *</label>
                    <span class="field-validation-valid labelValidacao"></span>
                    <input class="form-control" type="text" id="data-nascimento2" v-maska="'##/##/####'" v-model="inscricao.dtNascimentoFinanceiro">
                </div>
            </div>
        </div>
    </div>

</template>


<script>
    export default {
        name: "Etapa_3",
        components: {},
        props: {
            inscricao_value: {
                type: Object,
                required: true
            },
            instituicao_value: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                inscricao: { ...this.inscricao_value },
                instituicao: { ...this.instituicao_value }
            };
        },
        methods: {
        },
        mounted() {
        },
        computed: {
            isDisabledMesmaPessoa() {
                return this.inscricao.flMesmaPessoa;
            }
        },
        watch: {
            inscricao: {
                handler(newValue) {
                    this.$emit('update:inscricao_value', { ...newValue });
                },
                deep: true
            },
            instituicao: {
                handler(newValue) {
                    this.$emit('update:instituicao_value', { ...newValue });
                },
                deep: true
            }
        },
    };
</script>

<style scoped lang="scss">

    .container-formulario {
        background-color: #f8f8f8;
        padding: 0;
    }

    .painel {
        margin-top: 15px;
        margin-left: 80px;
        margin-right: 50px;
    }

    @media(min-width:992px) {
        .painel {
            margin-left: 40px;
            width: 200px;
            margin-right: 10px;
        }
    }

    @media(min-width:1200px) {
        .painel {
            margin-left: 40px;
            width: 220px;
            margin-right: 10px;
        }
    }

    @media(min-width:1350px) {
        .painel {
            margin-left: 40px;
            width: 250px;
            margin-right: 10px;
        }
    }


    @media(max-width:519px) {
        .painel {
            margin-left: 50px;
            margin-right: 50px;
        }
    }

    .conteudo {
        padding-left: 30px;
        padding-right: 40px;
    }

    @media(min-width:992px) {
        .conteudo {
            padding-left: 10px;
            margin-left: 150px;
        }
    }

    @media(min-width:1000px) {
        .conteudo {
            padding-left: 0px;
            margin-left: 150px;
        }
    }

    @media(min-width:1100px) {
        .conteudo {
            padding-left: 0px;
            margin-left: 150px;
        }
    }

    @media(min-width:1200px) {
        .conteudo {
            padding-left: 0px;
            margin-left: 150px;
        }
    }

    @media(min-width:1300px) {
        .conteudo {
            padding-left: 0px;
            margin-left: 150px;
        }
    }

    @media(min-width:1400px) {
        .conteudo {
            padding-left: 0px;
            margin-left: 140px;
        }
    }

    @media(min-width:1500px) {
        .conteudo {
            padding-left: 0px;
            margin-left: 130px;
        }
    }

    @media(min-width:1600px) {
        .conteudo {
            padding-left: 0px;
            margin-left: 120px;
        }
    }

    @media(min-width:1700px) {
        .conteudo {
            padding-left: 0px;
            margin-left: 100px;
        }
    }

    @media(min-width:1800px) {
        .conteudo {
            padding-left: 0px;
            margin-left: 80px;
        }
    }

    .linha-1 {
        border: 1px solid #d3d3d3;
        background-color: #fff;
        margin-left: 2px;
        margin-right: 2px;
        min-height: calc(100vh);
        border-top: none;
        border-bottom: none;
    }

    @media (min-width: 430px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            margin-left: 32px;
            margin-right: 32px;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 550px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            margin-left: 52px;
            margin-right: 32px;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 600px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            margin-left: 100px;
            margin-right: 70px;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 992px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            margin-left: calc(10vw - 30px) !important;
            margin-right: calc(10vw - 30px) !important;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 1200px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 1400px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 1500px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 1600px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 1800px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            border-top: none;
            border-bottom: none;
        }
    }

    .row > * {
        flex-shrink: 1;
    }

    .titulo {
        font-size: 14px;
        color: #bd2344;
        font-weight: 700
    }

    .titulo2 {
        font-size: 21px;
        line-height: 26px;
        color: #7a7a7a;
        margin-top: 5px;
        margin-bottom: 15px;
    }

    .texto-1 {
        font-size: 15px;
        line-height: 20px;
        color: #7a7a7a;
        margin-top: 5px;
    }

    .texto-2 {
        font-size: 15px;
        line-height: 20px;
        color: #7a7a7a;
    }

    .painel-2 {
        margin-top: 10px;
        margin-left: 80px;
        margin-right: 50px;
        padding: 16px;
        margin-bottom: 30px;
    }

    @media(min-width:992px) {
        .painel-2 {
            margin-top: 30px;
            margin-left: 40px;
            width: 200px;
            margin-right: 10px;
        }
    }

    @media(min-width:1200px) {
        .painel-2 {
            margin-top: 30px;
            margin-left: 40px;
            margin-right: 10px;
            width: 220px;
        }
    }

    @media(min-width:1350px) {
        .painel-2 {
            margin-left: 40px;
            width: 250px;
            margin-right: 10px;
        }
    }

    @media(max-width:519px) {
        .painel-2 {
            margin-left: 50px;
            margin-right: 50px;
        }
    }

    .painel-3 {
        display: block;
    }

    .btn-pagination {
        padding: 15px;
        border: none;
    }

    @media(min-width:992px) {
        .btn-pagination {
            padding: 15px;
        }
    }

    .btn-pagination2 {
        padding: 15px;
        border: none;
    }

    @media(min-width:992px) {
        .btn-pgnt2 {
            height: 0;
        }
    }

    .card-painel {
        margin-left: 40px;
        width: 220px;
        margin-right: 10px;
        margin-top: 30px;
    }

    @media(min-width:630px) {
        .card-painel {
            margin-left: 60px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:700px) {
        .card-painel {
            margin-left: 70px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:800px) {
        .card-painel {
            margin-left: 100px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:992px) {
        .card-painel {
            visibility: hidden;
            margin: 0;
            height: 0;
        }
    }


    .card-painel2 {
        margin-left: 40px;
        width: 220px;
        margin-right: 10px;
        margin-top: 30px;
        margin-bottom: 30px;
        padding: 16px;
    }

    @media(min-width:630px) {
        .card-painel2 {
            margin-left: 60px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:700px) {
        .card-painel2 {
            margin-left: 70px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:800px) {
        .card-painel2 {
            margin-left: 100px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:992px) {
        .card-painel2 {
            visibility: hidden;
            margin: 0;
            padding: 0;
            height: 300px;
            display: block;
        }
    }

    .card-painel3 {
        margin-left: 40px;
        width: 220px;
        margin-right: 10px;
        margin-top: 30px;
        margin-bottom: 30px;
        padding: 16px;
    }

    @media(min-width:630px) {
        .card-painel3 {
            margin-left: 60px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:700px) {
        .card-painel3 {
            margin-left: 70px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:800px) {
        .card-painel3 {
            margin-left: 100px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:992px) {
        .card-painel3 {
            visibility: hidden;
            margin: 0;
            padding: 0;
            height: 0;
            display: block;
        }
    }

    .active > .page-link,
    .page-link.active {
        margin-right: 15px !important;
        border-color: #ba2743 !important;
        color: #fff !important;
        background: #ba2743 !important;
        width: 37px !important;
        height: 39px !important;
        text-align: center !important;
        padding-top: 6px !important;
        border-radius: 0 !important;
        box-shadow: inset 0px 0px 0px 3px #fff !important;
        text-decoration: none !important;
        outline-style: none !important;
        z-index: 99 !important;
        margin-left: 10px !important;
        padding-bottom: 10px !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
        font-size: 16px !important;
    }


    .formularios {
        font-size: 22px;
        color: #bd2344;
        border-bottom: 1px solid #d3d3d3;
        padding-bottom: 10px;
        display: block;
    }

    .dados-instituicao {
        font-size: 18px;
        color: #bd2344;
        font-weight: 500;
        border-bottom: 1px solid#ececec;
        padding-bottom: 13px;
    }

    .logo {
        height: 34px;
        margin-bottom: 0px;
        margin-left: 10px;
        margin-right: 10px;
        float: right;
    }

    @media(max-width:991px) {
        .logo {
            visibility: hidden;
            height: 0;
            width: 0;
        }
    }

    @media(min-width:992px) {
        .logo {
            height: 34px;
            margin-right: 30px;
            margin-left: 10px;
            float: right;
        }
    }

    @media(min-width:1200px) {
        .logo {
            height: 34px;
            margin-right: 30px;
            margin-left: 10px;
            float: right;
        }
    }

    @media(min-width:1400px) {
        .logo {
            margin-right: 34px;
            float: right;
            height: 34px;
        }
    }

    @media(min-width:1537px) {
        .logo {
            margin-right: 34px;
            float: right;
            height: 34px;
        }
    }

    @media(min-width:1800px) {
        .logo {
            margin-right: 20px;
            float: right;
            height: 34px;
        }
    }

    .evento {
        margin-top: 30px;
        height: 80px;
        width: 150px;
        margin-bottom: 0px;
        margin-right: 20px;
        margin-left: 20px;
    }

    @media(min-width:330px) {
        .evento {
            margin-top: 30px;
            height: 180px;
            width: 250px;
            margin-bottom: 0px;
            margin-right: 20px;
            margin-left: 40px;
        }
    }

    @media(min-width:430px) {
        .evento {
            margin-top: 30px;
            height: 180px;
            width: 250px;
            margin-bottom: 0px;
            margin-right: 20px;
            margin-left: 60px;
        }
    }

    @media(min-width:530px) {
        .evento {
            margin-top: 30px;
            height: 180px;
            width: 250px;
            margin-bottom: 0px;
            margin-right: 20px;
            margin-left: 100px;
        }
    }

    @media(min-width:630px) {
        .evento {
            margin-top: 30px;
            height: 200px;
            width: 300px;
            margin-bottom: 0px;
            margin-right: 20px;
            margin-left: 70px;
        }
    }

    @media(min-width:700px) {
        .evento {
            margin-top: 30px;
            height: 250px;
            width: 400px;
            margin-bottom: 0px;
            margin-right: 20px;
            margin-left: 80px;
        }
    }

    @media(min-width:800px) {
        .evento {
            margin-top: 30px;
            height: 250px;
            width: 400px;
            margin-bottom: 0px;
            margin-right: 10px;
            margin-left: 120px;
        }
    }

    @media(min-width:920px) {
        .evento {
            margin-top: 30px;
            height: 250px;
            width: 400px;
            margin-bottom: 0px;
            margin-right: 10px;
            margin-left: 180px;
            margin-bottom: 0;
            align-self: center;
        }
    }

    @media(min-width:992px) {
        .evento {
            margin-top: 30px;
            height: 160px;
            width: 200px;
            margin-bottom: 0px;
            margin-right: 10px;
            margin-left: 40px;
        }
    }

    @media(min-width:1200px) {
        .evento {
            margin-top: 30px;
            height: 160px;
            width: 220px !important;
            margin-bottom: 0px;
            margin-right: 10px;
            margin-left: 40px;
        }
    }

    @media(min-width:1350px) {
        .evento {
            margin-top: 30px;
            height: 160px;
            width: 250px !important;
            margin-bottom: 0px;
            margin-right: 10px;
            margin-left: 40px;
        }
    }

    .descritivo {
        color: #777;
    }

    .informacao {
        border-color: #bbbbbb;
        margin-right: 1px;
        font-size: 14px;
    }

    .informacao2 {
        border-color: #bbbbbb;
        font-size: 14px;
    }

    .btn-danger {
        background-color: #bd2344;
        color: #fff;
        margin-top: 20px;
        font-size: 15px;
        font-weight: 700;
        padding: 10px 20px;
        border-radius: 0;
        border: 2px solid #ececec;
    }

    .icon-inscricao {
        padding-right: 5px;
        font-size: 15px;
    }

    .btn-inscricao {
        background-color: #bd2344;
        color: #fff;
        font-size: 15px;
        font-weight: 400;
        padding: 3px 5px;
        border-radius: 0;
        border: 2px solid #ececec;
    }

    @media(min-width:992px) {
        .btn-inscricao {
            background-color: #bd2344;
            color: #fff;
            font-size: 15px;
            font-weight: 400;
            padding: 3px 5px;
            border-radius: 0;
            border: 2px solid #ececec;
        }
    }

    #salvar {
        color: #fff;
        margin-top: 10px;
        margin-bottom: 10px;
        font-size: 15px;
        font-weight: 500;
        padding: 10px 20px;
        border-radius: 0;
        border: 2px solid #ececec;
        margin-right: 20px;
    }

    .btn-success {
        background-color: #158000;
        color: #fff;
        margin-top: 20px;
        font-size: 15px;
        padding: 10px 20px;
        font-weight: 500;
    }

    .footer {
        border-top: 1px solid #ececec;
        margin-top: 30px;
        border-color: #ddd;
    }

    .footer-2 {
        border-top: 1px solid #ececec;
        margin-top: 30px;
        border-color: #ddd;
        background-color: #f5f5f5;
    }

    .linha-2 {
        margin-left: 0px;
        margin-right: 0px;
        margin-top: 0;
        padding: 10px;
        background-color: #f5f5f5;
        border-color: #ddd;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        display: block;
    }

    .font-1 {
        font-weight: 600;
        font-size: 14px;
        color: #4c4c4c;
    }

    .font-2 {
        font-weight: 600;
        font-size: 14px;
        color: #575757;
        padding-left: 10px;
    }

    .font-3 {
        font-size: 13px;
        margin-bottom: 10px;
        padding-left: 10px;
    }


    @media(min-width:992px) {
        .font-3 {
            font-size: 13px;
            margin-bottom: 3px;
            padding-left: 10px;
        }
    }

    .font-4 {
        font-weight: 700;
        font-size: 16px;
        color: #4c4c4c;
    }

    .font-5 {
        font-weight: 700;
        font-size: 16px;
        color: #4c4c4c;
    }

    .font-6 {
        font-weight: 400;
        color: #707070;
    }

    .font-7 {
        font-weight: 400;
        font-size: 16px;
        color: #4c4c4c;
        margin-top: 20px;
    }

    .input-checkbox {
        margin-top: 23px;
    }

    .btn-secondary {
        background-color: #d8d8d8;
        color: #575757;
        margin-top: 20px;
        font-size: 15px;
        font-weight: 700;
        border: #bbbbbb;
        padding: 10px 20px;
        border-radius: 0;
    }

    .btn-secondary:hover {
        background-color: #d8d8d8;
        color: #575757;
    }

    .btn-link {
        border: 2px solid #f5f5f5;
        background: #f5f5f5;
        width: 37px;
        height: 39px;
        text-align: center;
        padding-top: 5px;
        border-radius: 0 !important;
        box-shadow: inset 0px 0px 0px 3px #fff !important;
        text-decoration: none;
        outline-style: none;
        z-index: 99;
        color: #bbb;
        background: #f5f5f5;
        margin-right: 15px;
        padding-bottom: 10px;
        padding-left: 0;
        padding-right: 0;
        font-size: 16px;
    }

    .btn-link-4 {
        border: 2px solid #f5f5f5;
        background: #f5f5f5;
        width: 43px;
        height: 45px;
        text-align: center;
        padding: 5px 0;
        border-radius: 0 !important;
        box-shadow: inset 0px 0px 0px 3px #fff !important;
        text-decoration: none;
        outline-style: none;
        z-index: 99;
        color: #bbb;
        background: #f5f5f5;
    }

    .cardbody {
        padding: 0;
    }

    .btn-pgnt {
        margin-bottom: 0;
    }

    .btn-pgnt2 {
        margin-bottom: 0;
    }

    @media(min-width:992px) {
        .btn-pgnt2 {
            height: 0;
        }
    }

    .container-2 {
        margin-left: 0;
        margin-top: 0;
    }

    .quantidade-participantes {
        border-color: #7a7a7a;
        font-size: 40px;
        box-shadow: 1px solid !important;
        color: #555 !important;
        font-weight: 600;
    }

    @media(min-width:992px) {
        .quantidade-participantes {
            border-color: #a8a8a8;
            margin-left: 90px;
            font-size: 40px;
        }
    }


    .m-quantidade-participantes {
        padding-top: 60px;
        padding-bottom: 40px;
    }

    #q-participantes {
        color: #4c4c4c;
        font-size: 20px;
        padding-left: 10px;
        font-weight: 600;
    }

    @media(min-width:992px) {
        #q-participantes {
            color: #4c4c4c;
            font-size: 20px;
            padding-left: 15px;
            font-weight: 600;
            margin-left: 95px;
        }
    }

    .paragrafo-1 {
        font-size: 16px;
        color: #96102d;
        padding-right: 40px;
        padding-left: 45px;
        font-weight: 400;
    }

    @media(min-width:992px) {
        .paragrafo-1 {
            font-size: 16px;
            padding-left: 0;
            padding-right: 0;
            margin-bottom: 0;
        }
    }

    .paragrafo-2 {
        font-size: 16px;
        color: #96102d;
        padding-left: 45px;
        padding-right: 40px;
        font-weight: 400;
    }

    @media(min-width:992px) {
        .paragrafo-2 {
            font-size: 16px;
            padding-right: 0;
            padding-left: 0;
        }
    }

    .corpo-col {
        padding-right: 0;
        margin-left: 10px;
    }

    @media(min-width:992px) {
        .corpo-col {
            margin-left: 130px;
            padding-right: 40px;
        }
    }

    .paragrafo-danger {
        font-size: 26px;
        text-align: center;
        color: #333;
        font-weight: 500;
    }
</style>